import { motion } from "framer-motion";
import { CONTACT } from "../lib/content";

const SITE_URL = "https://intolaw.co.za";

const WhatsAppIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
    <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.117.555 4.184 1.61 6.008L4 29l8.184-1.57a11.94 11.94 0 0 0 3.82.625h.004C22.629 28.055 28 22.672 28 16.05 28 9.43 22.625 3 16.004 3zm0 21.86h-.004a9.86 9.86 0 0 1-5.02-1.375l-.36-.215-4.855.93.972-4.73-.234-.375a9.83 9.83 0 0 1-1.51-5.246c0-5.45 4.437-9.883 9.89-9.883 2.64 0 5.122 1.03 6.988 2.898a9.82 9.82 0 0 1 2.898 6.992c0 5.45-4.437 9.883-9.765 9.883zm5.43-7.402c-.297-.148-1.758-.867-2.031-.965-.273-.098-.472-.148-.672.15-.199.296-.77.964-.945 1.163-.172.196-.348.223-.645.075-.297-.15-1.254-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.058-.172-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.15-.174.199-.298.298-.497.099-.198.05-.372-.025-.52-.074-.148-.672-1.62-.92-2.22-.243-.583-.49-.504-.672-.513l-.573-.01a1.1 1.1 0 0 0-.797.372c-.273.297-1.045 1.02-1.045 2.487s1.07 2.884 1.22 3.083c.148.198 2.105 3.214 5.1 4.505.712.307 1.268.49 1.7.628.714.227 1.364.195 1.878.118.573-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347z" />
  </svg>
);

export default function WhatsAppButtons() {
  const chatUrl = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
    "Hello IntoLaw, I would like to enquire about your legal consulting services."
  )}`;
  const shareUrl = `https://wa.me/?text=${encodeURIComponent(
    `Accessible legal solutions for businesses and individuals — IntoLaw. ${SITE_URL}`
  )}`;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-center gap-3">
      <motion.a
        href={shareUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-share-button"
        aria-label="Share IntoLaw on WhatsApp"
        title="Share on WhatsApp"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/10 bg-white text-navy shadow-lg transition-colors duration-300 hover:text-[#25D366]"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
        </svg>
      </motion.a>

      <motion.a
        href={chatUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-fab"
        aria-label="Chat with IntoLaw on WhatsApp"
        title="Chat on WhatsApp"
        whileHover={{ scale: 1.06 }}
        whileTap={{ scale: 0.95 }}
        className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" aria-hidden="true" />
        <WhatsAppIcon />
      </motion.a>
    </div>
  );
}
